export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";

export const SET_DASHBOARD = "SET_DASHBOARD";

export const SET_BVN_USERS = "SET_BVN_USERS";

export const SET_BVN_UNVERIFIED_USERS = "UNVERIFIED";
export const SET_BVN_VERIFIED_USERS = "VERIFIED";
export const SET_BVN_PENDING_USERS = "VERIFICATION_PENDING";
export const SET_BVN_LOADING = "BVN_LOADING";

export const SET_USERS = "SET_USERS";
export const SET_USER_TRANSACTIONS = "SET_USER_TRANSACTIONS";
export const VERIFY_USER = "VERIFY_USER";

export const SET_VERIFIED_USER = "SET_VERIFIED_USER";

export const CHANGE_USERNAME = "CHANGE_USERNAME";
